import React from "react";

const AddToBasket = (props) => {

  const renderSpinner = () => {
    return (
      <span className="product__favourite">
        <i className="fa fa-spinner fa-spin" />
      </span>
    );
  }

  const renderFavouriteIconLink = (iconClass, clickHandler, title) => {
    const { productId } = props;
    return (
      <a
        onClick={e => {
          e.preventDefault();
          clickHandler(productId);
        }}
        className="product__favourite"
        title={title}
      >
        <i className={`fa ${iconClass}`} />
      </a>
    );
  }

  const renderAddToBasketLink = () => {
    const { addProduct, translations } = props;
    return renderFavouriteIconLink("fa-star-o", addProduct, translations.add_to_favourites_tooltip);
  }


  const renderRemoveFromBasketLink = () => {
    const { removeProduct, translations } = props;
    return renderFavouriteIconLink("fa-star", removeProduct, translations.remove_from_favourites_tooltip);
  }

  
  const { productInBasket, addingProduct, removingProduct } = props;
  if (addingProduct || removingProduct) {
    return renderSpinner();
  } else if (productInBasket) {
    return renderRemoveFromBasketLink();
  } else {
    return renderAddToBasketLink();
  }
  
}

export default AddToBasket;
